module.exports = {
  emptyMessage: 'Kartta göründüğü gibi numarayı tamamlayın',
  defaultMessage: 'Girdiğiniz kart numarası geçersiz. Yazım hatası olmadığından emin olun ve tekrar deneyin.',
};
